<template>
  <div>
    <!-- 搜索区 -->
    <el-card style="margin-bottom: 20px">
      <el-form :model="query" inline>
        <el-form-item label="昵称">
          <el-input
            v-model="query.nickname"
            placeholder="请输入昵称"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="手机号">
          <el-input
            v-model="query.mobile"
            placeholder="请输入手机号"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="性别">
          <el-select v-model="query.gender" placeholder="请选择" clearable>
            <el-option label="男" :value="1"></el-option>
            <el-option label="女" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="认证类型">
          <el-select v-model="query.certType" placeholder="请选择" clearable>
            <el-option label="牛人认证" value="PERSONAL"></el-option>
            <el-option label="机构认证" value="BUSINESS"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="query.status" placeholder="请选择" clearable>
            <el-option label="正常" value="ENABLED"></el-option>
            <el-option label="禁用" value="DISABLED"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="search">搜索</el-button>
          <el-button @click="reset">重置</el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <!-- 表格区 -->
    <el-card>
      <el-table
        :data="list"
        border
        stripe
        v-loading="loading"
        style="width: 100%"
      >
        <el-table-column align="center" label="头像" width="70">
          <template slot-scope="{ row }">
            <el-avatar
              v-if="row.avatarUrl || row.avatar"
              :src="row.avatarUrl || row.avatar"
              size="small"
            ></el-avatar>
            <el-avatar
              v-else
              size="small"
              icon="el-icon-user-solid"
            ></el-avatar>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="nickname"
          label="昵称"
          width="120"
        ></el-table-column>
        <el-table-column align="center" label="性别" width="60">
          <template slot-scope="{ row }">
            <span
              v-if="
                row.gender === 1 || row.gender === '1' || row.gender === 'MALE'
              "
              >男</span
            >
            <span
              v-else-if="
                row.gender === 2 ||
                row.gender === '2' ||
                row.gender === 'FEMALE'
              "
              >女</span
            >
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="phone" label="手机号" width="130">
          <template slot-scope="{ row }">
            {{ row.phone || row.mobile || "-" }}
          </template>
        </el-table-column>
        <el-table-column align="center" label="认证类型" width="100">
          <template slot-scope="{ row }">
            <el-tag
              v-if="row.certType === 'BUSINESS'"
              type="warning"
              size="small"
              >机构认证</el-tag
            >
            <el-tag
              v-else-if="row.certType === 'PERSONAL'"
              type="success"
              size="small"
              >牛人认证</el-tag
            >
            <span v-else style="color: #999">未认证</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="状态" width="80">
          <template slot-scope="{ row }">
            <el-tag
              :type="displayStatus(row) === '正常' ? 'success' : 'danger'"
              size="small"
            >
              {{ displayStatus(row) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column
          prop="postCount"
          label="帖数"
          align="center"
          width="50"
        >
          <template slot-scope="{ row }">
            {{ row.postCount != null ? row.postCount : 0 }}
          </template>
        </el-table-column>
        <el-table-column
          width="160"
          prop="createTime"
          label="注册时间"
        ></el-table-column>
        <el-table-column label="操作" min-width="400">
          <template slot-scope="{ row }">
            <el-button type="text" @click="handleDetail(row)">详情</el-button>
            <el-button type="text" @click="handleViewPosts(row)"
              >查看帖子</el-button
            >
            <el-button type="text" @click="handleSessions(row)">会话</el-button>
            <el-button
              v-if="isNormal(row)"
              type="text"
              style="color: #f56c6c"
              @click="handleDisable(row)"
              >禁用</el-button
            >
            <el-button
              v-else
              type="text"
              style="color: #67c23a"
              @click="handleEnable(row)"
              >启用</el-button
            >
            <el-button type="text" @click="handleTogglePostLimit(row)">
              {{ isPostLimited(row) ? "取消发帖限制" : "限制发帖" }}
            </el-button>
            <el-button type="text" @click="handleToggleChatLimit(row)">
              {{ isChatLimited(row) ? "取消聊天限制" : "限制聊天" }}
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        style="margin-top: 20px; text-align: right"
        :current-page="query.page"
        :page-sizes="[10, 20, 50]"
        :page-size="query.pageSize"
        :total="total"
        layout="total, sizes, prev, pager, next"
        @size-change="handleSizeChange"
        @current-change="handlePageChange"
      ></el-pagination>
    </el-card>

    <!-- 详情弹窗 -->
    <el-dialog
      title="用户详情"
      :visible.sync="detailVisible"
      width="550px"
      @opened="onDetailOpened"
    >
      <el-descriptions v-if="currentUser" :column="2" border>
        <el-descriptions-item label="ID">{{
          currentUser.id
        }}</el-descriptions-item>
        <el-descriptions-item label="昵称">{{
          currentUser.nickname || "-"
        }}</el-descriptions-item>
        <el-descriptions-item label="头像">
          <el-avatar
            v-if="currentUser.avatarUrl || currentUser.avatar"
            :src="currentUser.avatarUrl || currentUser.avatar"
            size="small"
          ></el-avatar>
          <span v-else>-</span>
        </el-descriptions-item>
        <el-descriptions-item label="性别">
          {{ displayGender(currentUser) }}
        </el-descriptions-item>
        <el-descriptions-item label="年龄">{{
          userAge || "未设置"
        }}</el-descriptions-item>
        <el-descriptions-item label="手机号">{{
          userPhone || "-"
        }}</el-descriptions-item>
        <el-descriptions-item label="个人介绍" :span="2">{{
          userBio || "未设置"
        }}</el-descriptions-item>
        <el-descriptions-item label="擅长标签" :span="2">
          <template v-if="skillTags.length">
            <el-tag
              v-for="(tag, idx) in skillTags"
              :key="idx"
              size="small"
              style="margin-right: 5px"
              >{{ tag }}</el-tag
            >
          </template>
          <span v-else>未设置</span>
        </el-descriptions-item>
        <el-descriptions-item label="认证类型">
          <el-tag
            v-if="currentUser.certType === 'BUSINESS'"
            type="warning"
            size="small"
            >机构认证</el-tag
          >
          <el-tag
            v-else-if="currentUser.certType === 'PERSONAL'"
            type="success"
            size="small"
            >牛人认证</el-tag
          >
          <span v-else>未认证</span>
        </el-descriptions-item>
        <el-descriptions-item label="状态">
          <el-tag
            :type="displayStatus(currentUser) === '正常' ? 'success' : 'danger'"
            size="small"
          >
            {{ displayStatus(currentUser) }}
          </el-tag>
        </el-descriptions-item>
        <el-descriptions-item label="关注数">{{
          currentUser.followingCount != null ? currentUser.followingCount : 0
        }}</el-descriptions-item>
        <el-descriptions-item label="粉丝数">{{
          currentUser.followerCount != null ? currentUser.followerCount : 0
        }}</el-descriptions-item>
        <el-descriptions-item label="帖子数">{{
          currentUser.postCount != null ? currentUser.postCount : 0
        }}</el-descriptions-item>
        <el-descriptions-item label="私信">
          <el-button
            type="text"
            :disabled="isChatLimited(currentUser)"
            :style="
              isChatLimited(currentUser)
                ? 'color: #c0c4cc; cursor: not-allowed;'
                : ''
            "
            @click="handleDetailMessage"
          >
            {{ isChatLimited(currentUser) ? "您被限制私信" : "私信" }}
          </el-button>
        </el-descriptions-item>
        <el-descriptions-item label="注册时间">{{
          currentUser.createTime || "-"
        }}</el-descriptions-item>
      </el-descriptions>
      <div v-else style="text-align: center; padding: 20px; color: #999">
        加载中...
      </div>
    </el-dialog>

    <!-- 会话列表弹窗 -->
    <el-dialog
      :title="sessionDialogTitle"
      :visible.sync="sessionVisible"
      width="920px"
      @opened="fetchSessionList"
    >
      <div style="margin-bottom: 16px; color: #666">
        当前用户 ID：{{ currentUser ? currentUser.id : "-" }}
      </div>
      <el-table
        :data="sessionList"
        border
        stripe
        v-loading="sessionLoading"
        style="width: 100%"
      >
        <el-table-column
          prop="sessionId"
          label="会话ID"
          width="100"
        ></el-table-column>
        <el-table-column
          prop="peerUserId"
          label="对方用户ID"
          width="110"
        ></el-table-column>
        <el-table-column
          prop="peerNickname"
          label="对方昵称"
          width="140"
        ></el-table-column>
        <el-table-column
          prop="lastMessageContent"
          label="最后消息"
          min-width="220"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="lastMessageTime"
          label="最后消息时间"
          width="170"
        ></el-table-column>
        <el-table-column
          prop="unreadCount"
          label="未读"
          width="80"
        ></el-table-column>
        <el-table-column label="操作" width="120">
          <template slot-scope="{ row }">
            <el-button type="text" @click="handleOpenMessages(row)"
              >查看记录</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        style="margin-top: 16px; text-align: right"
        :current-page="sessionQuery.pageNum"
        :page-sizes="[10, 20, 50]"
        :page-size="sessionQuery.pageSize"
        :total="sessionTotal"
        layout="total, sizes, prev, pager, next"
        @size-change="handleSessionSizeChange"
        @current-change="handleSessionPageChange"
      ></el-pagination>
    </el-dialog>

    <!-- 聊天记录弹窗 -->
    <el-dialog
      :title="messageDialogTitle"
      :visible.sync="messageVisible"
      width="860px"
    >
      <div class="admin-chat-body" v-loading="messageLoading">
        <div v-if="messageList.length" class="admin-chat-list">
          <div
            v-for="msg in messageList"
            :key="msg.id"
            class="admin-msg-row"
            :class="msg.from === 'right' ? 'admin-msg-right' : 'admin-msg-left'"
          >
            <el-avatar
              class="admin-msg-avatar"
              :src="msg.senderAvatar || ''"
              :size="42"
              icon="el-icon-user-solid"
            ></el-avatar>
            <div class="admin-msg-body">
              <div class="admin-msg-name">
                {{ msg.senderName || "未知用户" }}
              </div>
              <div
                v-if="msg.messageType === 'IMAGE'"
                class="admin-msg-bubble admin-msg-image"
              >
                <el-image
                  class="admin-msg-picture"
                  :src="msg.mediaUrl"
                  :preview-src-list="msg.mediaUrl ? [msg.mediaUrl] : []"
                  fit="cover"
                ></el-image>
              </div>
              <div v-else class="admin-msg-bubble">
                {{ msg.content || "[空消息]" }}
              </div>
              <div class="admin-msg-time">{{ msg.createTime }}</div>
            </div>
          </div>
        </div>
        <el-empty v-else-if="!messageLoading" description="暂无消息"></el-empty>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getUsers,
  getUserDetail,
  disableUser,
  enableUser,
  limitUserPost,
  limitUserChat,
  getChatSessions,
  getChatMessages,
} from "../../api";

export default {
  name: "UserManage",
  data() {
    return {
      query: {
        nickname: "",
        mobile: "",
        gender: "",
        certType: "",
        status: "",
        page: 1,
        pageSize: 10,
      },
      list: [],
      total: 0,
      loading: false,
      detailVisible: false,
      currentUser: null,
      sessionVisible: false,
      sessionLoading: false,
      sessionList: [],
      sessionTotal: 0,
      sessionDialogTitle: "用户会话列表",
      sessionQuery: {
        pageNum: 1,
        pageSize: 10,
      },
      messageVisible: false,
      messageLoading: false,
      messageList: [],
      messageDialogTitle: "聊天记录",
      currentSessionId: null,
    };
  },
  computed: {
    userPhone() {
      return this.currentUser.phone || this.currentUser.mobile || "";
    },
    userAge() {
      const age = this.currentUser.age;
      return age != null && age !== "" ? age : "";
    },
    userBio() {
      return this.currentUser.bio || this.currentUser.introduction || "";
    },
    skillTags() {
      if (!this.currentUser) return [];
      const raw = this.currentUser.skillTags;
      if (!raw) return [];
      if (Array.isArray(raw)) return raw;
      if (typeof raw === "string") {
        try {
          const parsed = JSON.parse(raw);
          return Array.isArray(parsed) ? parsed : [];
        } catch (e) {
          return raw
            .split(/[\n,，]/)
            .map((s) => s.trim())
            .filter(Boolean);
        }
      }
      return [];
    },
  },
  created() {
    this.fetchList();
  },
  methods: {
    displayGender(user) {
      const g = user.gender;
      if (g === 1 || g === "1" || g === "MALE") return "男";
      if (g === 2 || g === "2" || g === "FEMALE") return "女";
      return "未设置";
    },
    displayStatus(user) {
      const s = user.status;
      if (s === 1 || s === "1" || s === "ENABLED") return "正常";
      return "禁用";
    },
    isNormal(user) {
      const s = user.status;
      return s === 1 || s === "1" || s === "ENABLED";
    },
    fetchList() {
      this.loading = true;
      getUsers(this.query)
        .then((res) => {
          this.list = res.data.records || res.data || [];
          this.total = res.data.total || 0;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    search() {
      this.query.page = 1;
      this.fetchList();
    },
    reset() {
      this.query = {
        nickname: "",
        mobile: "",
        gender: "",
        certType: "",
        status: "",
        page: 1,
        pageSize: 10,
      };
      this.fetchList();
    },
    handleSizeChange(val) {
      this.query.pageSize = val;
      this.fetchList();
    },
    handlePageChange(val) {
      this.query.page = val;
      this.fetchList();
    },
    handleDetail(row) {
      getUserDetail(row.id).then((res) => {
        const detail = res.data.user || res.data;
        // 列表数据可能已含 postCount/followingCount/followerCount，详情接口未必返回，合并保留
        this.currentUser = {
          postCount: 0,
          followingCount: 0,
          followerCount: 0,
          ...row,
          ...detail,
        };
        this.detailVisible = true;
      });
    },
    handleViewPosts(row) {
      this.$router.push({
        path: "/posts",
        query: {
          userId: row.id,
        },
      });
    },
    handleDetailMessage() {
      if (!this.currentUser || this.isChatLimited(this.currentUser)) {
        return;
      }
      this.handleSessions(this.currentUser);
    },
    handleSessions(row) {
      this.currentUser = row;
      this.sessionDialogTitle = `用户会话列表 - ${
        row.nickname || row.username || row.id
      }`;
      this.sessionVisible = true;
      this.sessionQuery.pageNum = 1;
      this.sessionList = [];
      this.sessionTotal = 0;
    },
    fetchSessionList() {
      if (!this.currentUser || !this.currentUser.id) return;
      this.sessionLoading = true;
      const params = {
        userId: this.currentUser.id,
        pageNum: this.sessionQuery.pageNum,
        pageSize: this.sessionQuery.pageSize,
      };
      getChatSessions(params)
        .then((res) => {
          const data = res.data || {};
          this.sessionList = data.records || data.rows || data || [];
          this.sessionTotal = data.total || 0;
        })
        .finally(() => {
          this.sessionLoading = false;
        });
    },
    handleSessionSizeChange(val) {
      this.sessionQuery.pageSize = val;
      this.sessionQuery.pageNum = 1;
      this.fetchSessionList();
    },
    handleSessionPageChange(val) {
      this.sessionQuery.pageNum = val;
      this.fetchSessionList();
    },
    handleOpenMessages(row) {
      this.currentSessionId = row.sessionId || row.id;
      this.messageDialogTitle = `聊天记录 - 会话 ${this.currentSessionId}`;
      this.messageVisible = true;
      this.messageList = [];
      this.fetchSessionMessages();
    },
    fetchSessionMessages() {
      if (!this.currentSessionId) return;
      this.messageLoading = true;
      getChatMessages(this.currentSessionId, { pageNum: 1, pageSize: 200 })
        .then((res) => {
          const data = res.data || {};
          const records = data.records || data.rows || data || [];
          const currentUserId =
            this.currentUser && this.currentUser.id
              ? String(this.currentUser.id)
              : "";
          this.messageList = records.map((item) => ({
            ...item,
            from: String(item.senderId) === currentUserId ? "right" : "left",
          }));
        })
        .finally(() => {
          this.messageLoading = false;
        });
    },
    onDetailOpened() {
      // 弹窗打开后确保数据已加载
      if (!this.currentUser) {
        this.$message.warning("未能获取用户详情");
      }
    },
    handleDisable(row) {
      this.$confirm("确定要禁用该用户吗？", "提示", { type: "warning" })
        .then(() => {
          disableUser(row.id).then(() => {
            this.$message.success("禁用成功");
            this.fetchList();
          });
        })
        .catch(() => {});
    },
    handleEnable(row) {
      enableUser(row.id).then(() => {
        this.$message.success("启用成功");
        this.fetchList();
      });
    },
    isPostLimited(row) {
      const value = row && row.postLimited;
      return value === 1 || value === "1" || value > 0;
    },
    isChatLimited(row) {
      const value = row && row.chatLimited;
      return value === 1 || value === "1" || value > 0;
    },
    handleTogglePostLimit(row) {
      const limited = this.isPostLimited(row);
      const tip = limited
        ? "确定要取消该用户的发帖限制吗？"
        : "确定要限制该用户发帖吗？";
      this.$confirm(tip, "提示", { type: "warning" })
        .then(() => {
          limitUserPost(row.id).then(() => {
            this.$message.success(limited ? "已取消发帖限制" : "已限制发帖");
            this.fetchList();
          });
        })
        .catch(() => {});
    },
    handleToggleChatLimit(row) {
      const limited = this.isChatLimited(row);
      const tip = limited
        ? "确定要取消该用户的聊天限制吗？"
        : "确定要限制该用户聊天吗？";
      this.$confirm(tip, "提示", { type: "warning" })
        .then(() => {
          limitUserChat(row.id).then(() => {
            this.$message.success(limited ? "已取消聊天限制" : "已限制聊天");
            this.fetchList();
          });
        })
        .catch(() => {});
    },
  },
};
</script>

<style scoped>
.admin-chat-body {
  min-height: 220px;
  max-height: 560px;
  overflow-y: auto;
  padding: 8px 4px;
  background: linear-gradient(180deg, #f8fafc 0%, #f4f6fb 100%);
  border-radius: 8px;
}

.admin-chat-list {
  display: flex;
  flex-direction: column;
}

.admin-msg-row {
  display: flex;
  align-items: flex-start;
  margin-bottom: 18px;
}

.admin-msg-left {
  flex-direction: row;
}

.admin-msg-right {
  flex-direction: row-reverse;
}

.admin-msg-avatar {
  flex-shrink: 0;
  margin: 0 12px;
  background: #fff;
}

.admin-msg-body {
  max-width: calc(100% - 84px);
  min-width: 0;
}

.admin-msg-right .admin-msg-body {
  text-align: right;
}

.admin-msg-name {
  font-size: 12px;
  line-height: 1.4;
  color: #8a8f99;
  margin-bottom: 6px;
}

.admin-msg-bubble {
  display: inline-block;
  max-width: 100%;
  padding: 12px 14px;
  border-radius: 14px;
  font-size: 14px;
  line-height: 1.65;
  word-break: break-word;
  background: #ffffff;
  color: #303133;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
}

.admin-msg-right .admin-msg-bubble {
  background: linear-gradient(90deg, #ff6b4a 0%, #ff8a3d 100%);
  color: #fff;
}

.admin-msg-image {
  padding: 8px;
}

.admin-msg-picture {
  display: block;
  width: 180px;
  height: 180px;
  border-radius: 10px;
  overflow: hidden;
}

.admin-msg-time {
  margin-top: 6px;
  font-size: 12px;
  color: #b0b4bc;
}
</style>
